module.exports = __webpack_public_path__ + "img/graphite.3cc0566f.png";